//
// LocationFeature.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "@sas-dvr/ltjs-commons/maps/MapSearchResult";
import "@sas-dvr/ltjs-commons/maps/MapSearchHint";
import "@sas-dvr/ltjs-commons/models/warnings/Warning";

var LocationFeature = createModule("gtl::LocationFeature", [], EventDispatcher, [
    ,
    ,
    ,
    {
        country: 7,
        address: 7,
        color: 4,
        latLon: 11,
        name: 7,
        description: 7,
        pixelLocation: 11,
    },
    {
        setVisible: [0,2],
        clearSearch: [0],
        search: [0,7,7,11,4],
        select: [0,2],
        getSearchHints: [[1]],
        getWarnings: [[1]],
        isSelected: [2],
        requestSearchHints: [0,7,4],
        setAddressFromReverseGeocode: [0],
        getSearchResults: [[1]],
        isVisible: [2],
    },
    ,
    ,
]);
export default LocationFeature;
